import { ControlConfig } from '../controlConfig';
import AddNewSignature from './AddNewSignature';
import ControlSignatureEngine from './ControlSignatureEngine';
import ControlSignatureEntry from './ControlSignatureEntry';
import ControlSignaturePlaceholder from './ControlSignaturePlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForSignatureEngine from './getYupSchemaForSignatureEngine';
import getYupSchemaForSignatureEntry from './getYupSchemaForSignatureEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlSignatureEngine,
  Entry: ControlSignatureEntry,
  Add: AddNewSignature,
  yupSchemaEngine: getYupSchemaForSignatureEngine,
  yupSchemaEntry: getYupSchemaForSignatureEntry,
  translator,
  Placeholder: ControlSignaturePlaceholder,
  previewCardHeight: '420px'
} as ControlConfig;
